/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): number | null {
		return fg('assets_custom_fields_limit_increase') ? 50 : null;
	},
};
